import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiFileText } from "react-icons/fi";
import { highlights, profile } from "../../data/profile";
import profileImage from "../../Assets/dp_reversed.jpg";

function Hero() {
  return (
    <section className="hero" aria-labelledby="hero-heading">
      <div className="container">
        <div className="hero__layout">
          <div className="hero__content">
            <p className="hero__status">
              <span className="hero__status-dot" aria-hidden="true" />
              Open to internships and software engineering roles
            </p>

            <h1 id="hero-heading" className="hero__name">
              {profile.name}
            </h1>

            <p className="hero__role">
              {profile.role} —{" "}
              <span className="hero__role-accent">{profile.focus}</span>
            </p>

            <p className="hero__summary">{profile.tagline}</p>

            <div className="hero__actions">
              <Link
                className="btn btn--primary"
                to={{ pathname: "/", hash: "#projects" }}
              >
                View projects
                <FiArrowRight aria-hidden="true" />
              </Link>
              <Link className="btn btn--secondary" to="/resume">
                <FiFileText aria-hidden="true" />
                Resume
              </Link>
            </div>
          </div>

          <figure className="hero__portrait">
            <img src={profileImage} alt={`${profile.name} profile illustration`} />
            <figcaption>Developer / builder</figcaption>
          </figure>
        </div>

        <dl className="hero__stats">
          {highlights.map((item) => (
            <div className="stat" key={item.label}>
              <dd className="stat__value">
                {item.value}
                {item.unit && <span className="stat__unit">{item.unit}</span>}
              </dd>
              <dt className="stat__label">{item.label}</dt>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}

export default Hero;
